if (!customElements.get('sticky-atc-bar')) {
  class StickyATCBar extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.productFormId = this.dataset.productFormId;

      const jsonEl = this.querySelector('[data-sticky-atc-variants-json]');
      this.data = jsonEl
        ? JSON.parse(jsonEl.textContent)
        : { variants: [], featured_image: null, savings_label: '', add_to_cart_text: '', sold_out_text: '' };

      this.image = this.querySelector('[data-sticky-atc-image] img');
      this.imageMobile = this.querySelector('[data-sticky-atc-image-mobile] img');
      this.titleVariant = this.querySelector('[data-sticky-atc-title-variant]');
      this.titleVariantMobile = this.querySelector('[data-sticky-atc-title-variant-mobile]');
      this.price = this.querySelector('[data-sticky-atc-price-current]');
      this.priceMobile = this.querySelector('[data-sticky-atc-price-current-mobile]');
      this.compare = this.querySelector('[data-sticky-atc-price-compare]');
      this.compareMobile = this.querySelector('[data-sticky-atc-price-compare-mobile]');
      this.savings = this.querySelector('[data-sticky-atc-savings]');
      this.savingsMobile = this.querySelector('[data-sticky-atc-savings-mobile]');
      this.submit = this.querySelector('[data-sticky-atc-submit]');
      this.submitMobile = this.querySelector('[data-sticky-atc-submit-mobile]');
    }

    connectedCallback() {
      this.handleScroll = this.handleScroll.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.submit?.addEventListener('click', this.onSubmit);
      this.submitMobile?.addEventListener('click', this.onSubmit);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll);

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        this.updateFromVariant(event?.data?.variant);
      });

      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.setLoading(false);
      });
      this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () => {
        this.setLoading(false);
      });

      this.initFromCurrentVariant();
      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      if (typeof this.variantChangeUnsubscriber === 'function') this.variantChangeUnsubscriber();
      if (typeof this.cartUpdateUnsubscriber === 'function') this.cartUpdateUnsubscriber();
      if (typeof this.cartErrorUnsubscriber === 'function') this.cartErrorUnsubscriber();
    }

    get mainSubmitButton() {
      return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    }

    initFromCurrentVariant() {
      const form = document.getElementById(this.productFormId);
      const currentId = form?.querySelector('input[name="id"]')?.value;
      if (!currentId) return;

      const v = this.data.variants.find((item) => item.id == currentId);
      if (v) this.applyVariant(v);
    }

    handleScroll() {
      const submitButton = this.mainSubmitButton;
      let shouldShow = false;

      if (submitButton) {
        const rect = submitButton.getBoundingClientRect();
        // Show once the main add-to-cart button has fully scrolled above the viewport
        shouldShow = rect.bottom < 0;
      } else {
        shouldShow = window.scrollY > 600;
      }

      this.classList.toggle('is-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

      if (shouldShow) {
        document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
        document.body.classList.add('sticky-atc-active');
      } else {
        document.body.classList.remove('sticky-atc-active');
      }
    }

    setLoading(loading) {
      [this.submit, this.submitMobile].forEach((btn) => {
        if (!btn) return;
        btn.classList.toggle('is-loading', loading);
      });
    }

    onSubmit(event) {
      event.preventDefault();

      const submitButton = this.mainSubmitButton;
      const form = document.getElementById(this.productFormId);

      if (!submitButton) {
        form?.requestSubmit?.();
        this.setLoading(true);
        return;
      }

      if (!submitButton.disabled && submitButton.getAttribute('aria-disabled') !== 'true') {
        this.setLoading(true);
        submitButton.click();
      }
    }

    updateFromVariant(variant) {
      if (!variant) return;

      const v = this.data.variants.find((item) => item.id == variant.id);
      if (v) this.applyVariant(v);
    }

    applyVariant(v) {
      const imageUrl = v.featured_image || this.data.featured_image;
      [this.image, this.imageMobile].forEach((img) => {
        if (img && imageUrl) img.src = imageUrl;
      });

      const variantTitle = v.title && v.title !== 'Default Title' ? ` \u2014 ${v.title}` : '';
      if (this.titleVariant) this.titleVariant.textContent = variantTitle;
      if (this.titleVariantMobile) this.titleVariantMobile.textContent = variantTitle;

      [this.price, this.priceMobile].forEach((el) => {
        if (el) el.textContent = v.price;
      });

      [this.compare, this.compareMobile].forEach((el) => {
        if (!el) return;
        if (v.compare_at_price) {
          el.textContent = v.compare_at_price;
          el.classList.remove('is-hidden');
        } else {
          el.classList.add('is-hidden');
        }
      });

      const savingsText = v.savings ? `${this.data.savings_label} ${v.savings}` : '';
      [this.savings, this.savingsMobile].forEach((el) => {
        if (!el) return;
        if (v.savings) {
          el.textContent = savingsText;
          el.classList.add('is-visible');
        } else {
          el.classList.remove('is-visible');
        }
      });

      const label = v.available ? this.data.add_to_cart_text : this.data.sold_out_text;
      [this.submit, this.submitMobile].forEach((btn) => {
        if (!btn) return;
        btn.textContent = label;
        btn.disabled = !v.available;
      });
    }
  }

  customElements.define('sticky-atc-bar', StickyATCBar);
}
